import {
  MODALIDADE_GRUPOS_ATIVOS,
  labelModalidadeEnsino,
  type ModalidadeGrupoId,
} from './modalidadeGrupos'
import type { CalendarioExcecao, ModalidadeEnsino } from '../types/database'

export type ExcecaoAgrupada = {
  key: string
  data: string
  /** Null quando a modalidade do banco não pertence a nenhum grupo ativo (ex.: médio, integral). */
  grupoId: ModalidadeGrupoId | null
  label: string
  motivo: string | null
  ids: string[]
}

/** Mapeia chave PNAE do banco para grupo ativo da UI. Creche legado também → Infantil. */
export function grupoIdDeModalidade(modalidade: ModalidadeEnsino): ModalidadeGrupoId | null {
  if (modalidade === 'creche' || modalidade === 'pre') return 'infantil'
  const grupo = MODALIDADE_GRUPOS_ATIVOS.find((g) => g.keys.includes(modalidade))
  return grupo?.id ?? null
}

/** Linhas para insert em calendario_excecoes (Infantil → só `pre`). Rejeita grupo inativo. */
export function rowsInsertExcecao(
  data: string,
  grupoId: ModalidadeGrupoId,
  motivo: string | null,
): { data: string; modalidade: ModalidadeEnsino; motivo: string | null }[] {
  const grupo = MODALIDADE_GRUPOS_ATIVOS.find((g) => g.id === grupoId)
  if (!grupo) {
    throw new Error(
      `Modalidade "${grupoId}" não possui grupo de cardápio ativo; não é possível gravar exceção de calendário.`,
    )
  }
  return grupo.keys.map((modalidade) => ({
    data,
    modalidade,
    motivo,
  }))
}

/** Agrupa exceções do banco para exibição (Infantil unifica creche + pre). */
export function agruparExcecoes(excecoes: CalendarioExcecao[]): ExcecaoAgrupada[] {
  const map = new Map<string, ExcecaoAgrupada>()

  for (const row of excecoes) {
    const grupoId = grupoIdDeModalidade(row.modalidade)
    // Modalidades sem grupo ativo ficam isoladas (não herdam Infantil).
    const key =
      grupoId != null ? `${row.data}:${grupoId}` : `${row.data}:sem-grupo:${row.modalidade}`
    const existing = map.get(key)
    if (existing) {
      existing.ids.push(row.id)
      if (!existing.motivo && row.motivo) existing.motivo = row.motivo
      continue
    }
    map.set(key, {
      key,
      data: row.data,
      grupoId,
      label: labelModalidadeEnsino(row.modalidade),
      motivo: row.motivo,
      ids: [row.id],
    })
  }

  return [...map.values()].sort((a, b) => a.data.localeCompare(b.data) || a.label.localeCompare(b.label))
}
